import styled from 'styled-components';

interface ContainerProps {
  maxWidth?: string;
  padding?: string;
  children: React.ReactNode;
}

const StyledContainer = styled.div<{
  maxWidth: string;
  padding: string;
}>`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth};
  padding: ${({ padding }) => padding};
  margin: 0 auto;
`;

export const Container: React.FC<ContainerProps> = ({
  maxWidth = '1200px',
  padding = '0 1rem',
  children,
  ...props
}) => {
  // Adjust padding to be responsive based on screen size
  const responsivePadding = `0 ${window.innerWidth < 640 ? '1rem' : window.innerWidth < 1024 ? '2rem' : '1rem'}`;

  return (
    <StyledContainer maxWidth={maxWidth} padding={padding || responsivePadding} {...props}>
      {children}
    </StyledContainer>
  );
};

export default Container; 